import { dynamic } from '#/utils/dynamic';

export const listingModalComponentByType = {
  SHARE_LISTING: dynamic(
    () =>
      import('./ShareListing/ShareListingModal').then((module) => ({
        default: module.ShareListingModal,
      })),
    { strategy: 'always' },
  ),
  FLAG_LISTING: dynamic(
    () =>
      import('./FlagListing/FlagListingModalContainer').then((module) => ({
        default: module.FlagListingModalContainer,
      })),
    { strategy: 'always' },
  ),
  EMAIL_ALERT: dynamic(
    () =>
      import('./EmailAlert/EmailAlertModalContainer').then((module) => ({
        default: module.EmailAlertModalContainer,
      })),
    { strategy: 'always' },
  ),
  ADMIN_REQUEST: dynamic(
    () =>
      import('./AdminRequest/AdminRequestModal').then((module) => ({
        default: module.AdminRequestModal,
      })),
    { strategy: 'always' },
  ),
  MARK_APPLIED: dynamic(
    () =>
      import('./MarkApplied/MarkAppliedModalContainer').then((module) => ({
        default: module.MarkAppliedModalContainer,
      })),
    { strategy: 'always' },
  ),
} as const satisfies Record<string, unknown>;
